import React from "react";
import { FiveXTSScore, FunctionalReachScore } from "../../models/reports";
import { useRecoilValue } from "recoil";
import { PatientState } from "../../data/atoms";
import { convertDOBintoAge } from "../../utils/sharedFunction";
import CustomBarGraph from "../Graphs/CustomBarGraph";

interface Props {
  score: FunctionalReachScore;
}
const FunctionalReach_Test: React.FC<Props> = ({ score }) => {
  const patientInfo = useRecoilValue(PatientState);

  let forwardOption = {
    graphName: "ForwardReach",
    graphSVG: (
      <svg
        width="23"
        height="36"
        viewBox="0 0 23 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_15994_62233)">
          <path
            d="M8.06015 7.25C8.77803 7.25 9.46651 6.97344 9.97412 6.48116C10.4817 5.98887 10.7669 5.32119 10.7669 4.625C10.7669 3.92881 10.4817 3.26113 9.97412 2.76884C9.46651 2.27656 8.77803 2 8.06015 2C7.34227 2 6.65379 2.27656 6.14618 2.76884C5.63856 3.26113 5.35338 3.92881 5.35338 4.625C5.35338 5.32119 5.63856 5.98887 6.14618 6.48116C6.65379 6.97344 7.34227 7.25 8.06015 7.25ZM7.60902 9C5.61842 9 4 10.5695 4 12.5V17.75V17.7828V28.25C4 29.218 4.80639 30 5.80451 30C6.80263 30 7.60902 29.218 7.60902 28.25V21.25H8.51128V28.25C8.51128 29.218 9.31767 30 10.3158 30C11.3139 30 12.1203 29.218 12.1203 28.25V12.3906H14.1504C14.9398 12.3906 15.6786 12.3906 16.2932 12.3906H16.9699C17.968 12.3906 19 11.7344 19 10.75C19 9.76562 18.3064 9 17.3083 9H15.391H13.2594C11.782 9 10.9981 9 9.45301 9H7.60902Z"
            fill="black"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_15994_62233"
            x="0"
            y="0"
            width="23"
            height="36"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_15994_62233"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_15994_62233"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    ),
    graphTitle: "Forward Reach",
    graphTitleDesc: "",
    graphNormValue: 0,
    isgraphNorm: false,
    graphActualValue: [score?.ForwardReach],
    graphActualValueLabel: [`${(score?.ForwardReach).toFixed(1)}`],
    graphRange: [4, 8, 12, 16],
    graphRangeLabel: ["4", "8", "12", "16"],
    graphNoLines: [],
    minMax: false,
    graphUnit: "Inches",
    graphAge: convertDOBintoAge(new Date(patientInfo?.dob)),
  };
  let lateralOption = {
    graphName: "LateralReach",
    graphSVG: (
      <svg
        width="25"
        height="36"
        viewBox="0 0 25 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_15994_62247)">
          <path
            d="M10.9961 7.56641C11.7772 6.78541 13.0441 6.78538 13.8252 7.56641L14.9297 8.6709C15.1987 8.94009 15.3725 9.26767 15.4561 9.6123C14.4885 9.60857 13.7094 9.54667 13.2666 9.48438C12.3025 9.34875 11.4109 10.016 11.2754 10.9736C11.1402 11.931 11.8116 12.8173 12.7754 12.9531C12.9524 12.978 13.1639 13.0023 13.4043 13.0244L8.51855 17.9111C8.29232 18.1373 8.02435 18.2955 7.74023 18.3906V28.3516C7.74023 29.2619 7.00213 30 6.0918 30C5.18158 29.9999 4.44336 29.2618 4.44336 28.3516V16.7256H4.5127C3.80655 15.9405 3.82958 14.7331 4.58496 13.9775L10.9961 7.56641ZM18.7773 9.91211C19.5016 9.76392 20.2092 10.227 20.3574 10.9463C20.5054 11.6656 20.0377 12.3688 19.3135 12.5176C18.2686 12.7317 15.6388 13.0264 12.9951 12.584C12.3577 12.4771 11.9019 11.9384 11.8809 11.3203V11.1748C11.8823 11.1366 11.8861 11.0982 11.8916 11.0596C11.9159 10.888 11.9784 10.7313 12.0684 10.5957C12.3432 10.1358 12.8825 9.86623 13.4443 9.95996C15.6867 10.3353 17.974 10.0768 18.7773 9.91211ZM17.2139 2C18.8994 2.00016 20.2654 3.37556 20.2656 5.07227C20.2656 6.76914 18.8995 8.14535 17.2139 8.14551C15.5281 8.14551 14.1611 6.76924 14.1611 5.07227C14.1613 3.37546 15.5282 2 17.2139 2Z"
            fill="black"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_15994_62247"
            x="0"
            y="0"
            width="24.3848"
            height="36"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_15994_62247"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_15994_62247"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    ),
    graphTitle: "Lateral Reach",
    graphTitleDesc: "",
    graphNormValue: 0,
    isgraphNorm: false,
    graphActualValue: [score.LeftReach, score.RightReach],
    graphActualValueLabel: [
      score.LeftReach.toFixed(1).toString(),
      score.RightReach.toFixed(1).toString(),
    ],
    graphRange: [0, 10, 20, 30, 40],
    graphRangeLabel: ["0", "10", "20", "30", "40"],
    graphNoLines: ["L", "R"],
    minMax: false,
    graphUnit: "Inches",
    graphAge: convertDOBintoAge(new Date(patientInfo?.dob)),
  };

  return (
    <>
      {score && score?.ForwardReach != 0 && !isNaN(score?.ForwardReach) && (
        <CustomBarGraph options={forwardOption} />
      )}
      {score &&
        (score?.LeftReach != 0 || score?.RightReach != 0) &&
        (!isNaN(score?.LeftReach) || !isNaN(score?.RightReach)) && (
          <CustomBarGraph options={lateralOption} />
        )}
    </>
  );
};

export default FunctionalReach_Test;
